export const DEFAULT_ROWS_PER_PAGE = 10;
export const ROWS_PER_PAGE_OPTIONS = [5, 10, 15];
export const SEARCH_DEBOUNCE_MS = 300;
export const EMPTY_ROW_KEY = 'empty-row';
export const STATUS_ROW_KEY = 'status-row';

export const ColumnIds = {
  Id: 'id',
  AccreditationOrganization: 'accreditationOrganization',
  AccreditContactIdentifier: 'accreditContactIdentifier',
  AddedToChampionshipContacts: 'addedToChampionshipContacts',
  Area: 'area',
  Email: 'email',
  FirstName: 'firstName',
  LastName: 'lastName',
  MobileNumber: 'mobileNumber',
  Name: 'name',
  RegistrationStatus: 'registrationStatus',
  RegistrationNumber: 'registrationNumber',
  Role: 'role',
  SubCategory: 'subCategory',
  DateOfBirth: 'dateOfBirth',
  ContactImage: 'contactImage',
  AccreditationDocument: 'accreditationDocument',
  NominatedForDinner: 'nominatedForDinner',
} as const;

export enum ContactRegistrationStatusValues {
  Pending = 'Pending',
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Invited = 'Invited',
  MoreInfoRequested = 'More Info Requested',
}

export enum PlayerRegistrationStatusValues {
  NotRegistered = 'Not Registered',
  PreRegistrationComplete = 'Pre-Registration Complete',
  Registered = 'Registered',
}
